export default __webpack_public_path__ + "static/media/User.8ae00e26.svg";